/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
  GetApiV1PersonSharedExperienceLevelDropdown401,
  GetApiV1PersonSharedExperienceLevelDropdown500,
} from "../../types/personSharedController/GetApiV1PersonSharedExperienceLevelDropdown.ts";

function getGetApiV1PersonSharedExperienceLevelDropdownUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/person/shared/experience-level-dropdown` as const,
  };
  return res;
}

/**
 * @description Retorna todas as opções do enumerador EExperienceLevel para uso em componentes de seleção. **(Requer Authorization para autenticação)**
 * @summary Lista de nível de experiência para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/person/shared/experience-level-dropdown}
 */
export async function getApiV1PersonSharedExperienceLevelDropdown(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1PersonSharedExperienceLevelDropdownQueryResponse,
    ResponseErrorConfig<
      | GetApiV1PersonSharedExperienceLevelDropdown401
      | GetApiV1PersonSharedExperienceLevelDropdown500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1PersonSharedExperienceLevelDropdownUrl().url.toString(),
    ...requestConfig,
  });
  return res.data;
}
